 
<!-- <dx-drop-down-button
text="Taranan Dosyayı Al"
[dropDownOptions]="{ width: 230 }"
icon="save"
[items]="pdfPage"
(onItemClick)="onItemClick($event)"
></dx-drop-down-button> -->

<dx-button
[text]="'DABS Tarama'"
type="default"
stylingMode="contained"
(click)="doScan()"
></dx-button>

<ng-container>
    
    <dx-popup
    [visible]="showScannedDocument"
     [height]="'690px'"
    [width]="'1120px'"
    title="DABS2 Taranan Dosya"
    (onHiding)="closePdfPreview($event)"
    contentStyle="padding: 0;"
  >  
  <div *dxTemplate="let data of 'content'" >
<div  class="popup-content-area">

    <div class="popup-content-area-item">

    <iframe
    style="width: 100%; height: 98%;"
    type="application/pdf"
      [src]="fileUrl"
    ></iframe>
</div>
    <div class="popup-content-area-operations">

      <dx-button     class="operations-button"
      stylingMode="contained" [width]="150" type="danger" text="İptal" (onClick)="closePdfPreview($event)"
        ></dx-button>
      <dx-button     class="operations-button"
       stylingMode="contained" [width]="150" type="default" text="Kaydet"
        (onClick)="saveBase64File()"></dx-button>
</div>
</div>
    
</div>

</dx-popup>


</ng-container>



<ng-container>
    
  <dx-popup
  [visible]="showOpenScanApp"
   [height]="dabsArkaPlandaBekleniyor ? '265px' : '220px'"
  [width]="'430px'"
  title="DABS2 Tarama"
  (onHiding)="closeScanApp()"
  contentStyle="padding: 0;"
>  
<div *dxTemplate="let data of 'content'" >
<div  class="info-popup-content-area">

  <div class="info-popup-content-area-item">

<h6>Uyarı</h6>
<p>DaBS2 Uygulamasının Açık Olması Gerekiyor!</p>
<!-- DKM-5487 Cedric: uyarı açıkken DABS arka planda bekleniyor; açılınca bağlantı kendiliğinden kurulur -->
<p class="info-popup-ipucu" *ngIf="dabsArkaPlandaBekleniyor">"Aç"a basın ya da DABS'ı masaüstünden açın; açıldığında bağlantı kendiliğinden kurulur.</p>
</div>
  <div class="info-popup-content-area-operations">

    <dx-button     class="info-popup-button"
    stylingMode="contained" [width]="150" type="danger" text="İptal" (onClick)="closeScanApp()"
      ></dx-button>
      <!-- <dx-button    class="info-popup-button"
      stylingMode="contained" [width]="150" type="success" text="Uygulamayı İndir"  
      (click)="downloadScanApp()" ></dx-button> -->
    <dx-button     class="info-popup-button"
     stylingMode="contained" [width]="150" type="default" text="Aç"
      (onClick)="openScanApp()"></dx-button>
</div>
<a style="float:right;margin: 10px 0px auto;" href="assets/DABS2-1.0.4.exe">Uygulamayı indir</a><br /> 

</div>
  
</div>

</dx-popup>


</ng-container>
 




<ng-container>
    
  <dx-popup
  [visible]="showScanLoading"
   [height]="'250px'"
  [width]="'430px'"
  title="DABS2 Tarama"
  (onHiding)="beklemePenceresiKapandi()"
  contentStyle="padding: 0;"
>  
<div *dxTemplate="let data of 'content'" >
<div  class="info-popup-content-area">

  <div class="info-popup-content-area-item">

<h6>Tarama Bekleniyor...</h6>
<!-- DKM-5339 Clara: kullanıcıya ne yapacağı ve "Aç"tan sonra DABS'ın açılmasının beklendiği söylenir -->
<p class="info-popup-ipucu" *ngIf="!dabsAciliyor">DABS penceresinde taradıktan sonra <b>Dab App Gönder</b>'e basın.</p>
<!-- DKM-5487 Cedric: eski hâli: <p class="info-popup-ipucu" *ngIf="dabsAciliyor">DABS açılıyor, bağlantı bekleniyor…</p> -->
<p class="info-popup-ipucu" *ngIf="dabsAciliyor">DABS açılıyor, bağlantı bekleniyor… Açılmazsa DABS'ı masaüstünden açın.</p>
</div>
<div class="info-popup-content-version">
  v1.0.4
</div>
  <div class="info-popup-content-area-operations">

    <dx-button     class="info-popup-button"
    stylingMode="contained" [width]="150" type="danger" text="İptal" (onClick)="cancelScanJob()"
      ></dx-button>
</div>
</div>
  
</div>

</dx-popup>


</ng-container>
 